var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-w-full ui-h-full"},[_c('div',{staticClass:"quotation-mark-bg ui-absolute ui-top-0 ui-left-0 ui-w-full ui-h-full"}),_c('div',{staticClass:"quotation-mark-bg ui-absolute ui-bottom-0 ui-right-0 ui-transform ui-rotate-180 ui-w-full ui-h-full"})])
}]

export { render, staticRenderFns }